import React, { useEffect, useState } from "react";
import apiClient from "../apiClient";
import { toast } from "react-toastify";

const PendingReceivePopup = ({ shopId, shopName }) => {
  const [pendingReceives, setPendingReceives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [productDetails, setProductDetails] = useState({});

  const fetchPendingReceives = async () => {
    try {
      setLoading(true);
      const res = await apiClient.post("/Liquor/GetPendingReceives", {
        shopId: Number(shopId),
      });
      if (res.data?.data?.length > 0) {
        setPendingReceives(res.data.data);
        setVisible(true);
      } else {
        setVisible(false);
      }
    } catch (err) {
      console.error("PendingReceive fetch error:", err);
      toast.error("Failed to load pending approvals");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shopId) fetchPendingReceives();
  }, [shopId]);

  const toggleProducts = async (receivedId) => {
    if (expandedId === receivedId) {
      setExpandedId(null);
      return;
    }
    setExpandedId(receivedId);
    if (productDetails[receivedId]) return;
    try {
      const res = await apiClient.post("/Liquor/GetStgReceivedProducts", { receivedId });
      setProductDetails((prev) => ({ ...prev, [receivedId]: res.data?.data || [] }));
    } catch {
      setProductDetails((prev) => ({ ...prev, [receivedId]: [] }));
    }
  };

  const handleApproveReject = async (receivedId, isApproved) => {
    try {
      setLoading(true);
      await apiClient.post("/Liquor/ApproveReject", {
        receivedId,
        isApproved,
        action: isApproved ? "Approve" : "Reject",
      });
      toast.success(isApproved ? "Approved Successfully" : "Rejected Successfully");
      const updated = pendingReceives.filter((x) => x.receivedId !== receivedId);
      setPendingReceives(updated);
      if (updated.length === 0) setVisible(false);
    } catch {
      toast.error("Failed to process request");
    } finally {
      setLoading(false);
    }
  };

  if (!visible || !pendingReceives.length) return null;

  return (
    <div className="pending-popup d-flex align-items-center justify-content-center">
      <div className="pending-card">

        {/* Header */}
        <div className="pending-header">
          <div>
            <h5 className="pending-title">Pending Approvals</h5>
            <span className="pending-badge">{pendingReceives.length} Pending</span>
          </div>
          <button className="pending-close-btn" onClick={() => setVisible(false)}>✕</button>
        </div>

        {/* Body */}
        <div className="pending-body">
          {pendingReceives.map((item) => (
            <div key={item.receivedId} className="pending-item">

              {/* Shop Name */}
              <div className="pending-shop-row">
                <span className="pending-label">From Shop</span>
                <span className="pending-shop-name">{item.shopName}</span>
              </div>

              {/* Transaction & Invoice */}
              <div className="pending-info-grid">
                <div className="pending-info-cell">
                  <span className="pending-label">Transaction</span>
                  <span className="pending-value-highlight">{item.transactionNumber}</span>
                </div>

              </div>

              {/* Remark */}
              <div className="pending-remark-row">
                <span className="pending-label">Remark</span>
                <span className="pending-remark-text">{item.remark || "—"}</span>
              </div>

              {/* Product Toggle */}
              <button
                className="pending-toggle-btn"
                onClick={() => toggleProducts(item.receivedId)}
              >
                {expandedId === item.receivedId ? "▲ Hide Products" : "▼ View Products"}
              </button>

              {expandedId === item.receivedId && (
                <div className="pending-products-wrap">
                  {!productDetails[item.receivedId] ? (
                    <div className="pending-loading">Loading...</div>
                  ) : productDetails[item.receivedId].length === 0 ? (
                    <div className="pending-loading">No product details found</div>
                  ) : (
                    <table className="pending-product-table">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Packing</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productDetails[item.receivedId].map((p, i) => (
                          <tr key={i}>
                            <td>{p.productName || p.pName || p.name}</td>
                            <td>{p.variant || "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}

              {/* Actions */}
              <div className="pending-actions">
                <button
                  className="btn-approve"
                  disabled={loading}
                  onClick={() => handleApproveReject(item.receivedId, true)}
                >
                  ✓ Approve
                </button>
                <button
                  className="btn-reject"
                  disabled={loading}
                  onClick={() => handleApproveReject(item.receivedId, false)}
                >
                  ✗ Reject
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default PendingReceivePopup;
